<template>
  <el-container id="resvSeeGl">
    <el-header style="height:38px;line-height:30px;padding-left:16px;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="resvSee_main">
      <el-main :style=divStyle>
        <div style="display:flex;height:9vh;width:100%;margin:0">
          <div style="display:flex;width:33.3%;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:auto;margin:1vh">
              <p style="margin:0;font-weight:bold;color: #6B7280">待审核预约</p>
              <div style="display:flex;font-weight:bold;margin-top:0;margin-left:3px;font-size:20px">
                <p style="margin:0">客户 {{ notStarted }}</p>
                <p style="margin-left:10px;margin-top: 0;margin-bottom: 0">同行 {{ notStarted }}</p>
              </div>
            </div>
          </div>
          <div
              style="display:flex;width:33.3%;margin-left:5px;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:auto;margin:1vh">
              <p style="margin:0;font-weight:bold;color: #6B7280">审核通过预约</p>
              <div style="display:flex;font-weight:bold;margin-top:0;margin-left:3px;font-size:20px">
                <p style="margin:0">客户 {{ notStarted }}</p>
                <p style="margin-left:10px;margin-top: 0;margin-bottom: 0">同行 {{ notStarted }}</p>
              </div>
            </div>
          </div>
          <div
              style="display:flex;width:33.3%;margin-left:5px;background-color:#FFFFFF;border-radius: 5px 5px 5px 5px;">
            <div style="width:auto;margin:1vh">
              <p style="margin:0;font-weight:bold;color: #6B7280">审核不通过预约</p>
              <div style="display:flex;font-weight:bold;margin-top:0;margin-left:3px;font-size:20px">
                <p style="margin:0">客户 {{ notStarted }}</p>
                <p style="margin-left:10px;margin-top: 0;margin-bottom: 0">同行 {{ notStarted }}</p>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;margin-top:5px;max-width:100%;">
          <div style="width:49.5%;padding-left:1vh;background-color: #FFFFFF">
            <p>预约趋势
              <el-radio-group v-model="but_qs" style="margin-left:5px" @change="getAppointInOneDay">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="周"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
              </el-radio-group>
              <el-date-picker
                  v-model="ediDay"
                  type="date"
                  @change="getAppointInOneDay"
                  :clearable="false"
                  placeholder="选择日期">
              </el-date-picker>
            </p>
            <div style="height: 20vh">
              <div id="myChart4" style="width:100%; height:100%;margin-bottom:0px"> <!--曲线图-->
              </div>
            </div>
          </div>
          <div style="width:49%;padding-left:1vh;margin-left:5px;background-color: #FFFFFF">
            <p>预约类型占比
              <el-radio-group v-model="but_zb" style="margin-left:5px" @change="getAppointRatio">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="周"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
              </el-radio-group>
              <el-date-picker
                  v-model="ediDayZb"
                  type="date"
                  @change="getAppointRatio"
                  :clearable="false"
                  placeholder="选择日期">
              </el-date-picker>
            </p>
            <div style="height: 20vh">
              <div id="myChart1" style="width:100%; height:100%;margin-bottom:0px"> <!--饼状图-->
              </div>
            </div>
          </div>
        </div>
        <div
            style="height:40px;margin-top:6px;padding-top:5px;padding-left:10px;background:#FFFFFF;display:flex;align-items: center">
          <div @click="onSet(0)" :class="isSet? 'actSee':'actSee1'"
               style="height:100%;width:120px;display:flex;justify-content: center;align-items: center">
            <p style="width:auto;height:auto;">预约记录</p>
          </div>
          <div @click="onSet(1)" :class="isSet? 'actSee1':'actSee'"
               style="height:100%;width:120px;display:flex;justify-content: center;align-items: center">
            <p style="width:auto;height:auto;">预约设置</p>
          </div>
        </div>
        <div v-if="isSet" style="height:auto;padding-left:20px;padding-right:10px;padding-top:10px;background:#FFFFFF">
          <div style="height:40px;display:flex;align-items: center">
            <p style="margin:0;width:120px">开启参观预约</p>
            <el-switch v-model="edi_pwr" @change="KeepInfo" style="margin-left:0px"></el-switch>
            <p style="margin-left:80px;width:150px">开启同行预约审批</p>
            <el-switch v-model="edi_needApprovalType1" @change="KeepInfo" style="margin-left:0px"></el-switch>
            <p style="margin-left:80px;width:150px">开启客户预约审批</p>
            <el-switch v-model="edi_needApprovalType2" @change="KeepInfo" style="margin-left:0px"></el-switch>
          </div>
          <div style="height:60px;display:flex;align-items: center">
            <p style="margin:0">可预约日期范围</p>
            <p style="margin-left:20px">最近</p>
            <el-input-number v-model="edi_day" :min="1" :max="100" :step="1" @change="KeepInfo"
                             style="margin: 0 6px">
            </el-input-number>
            <p>天</p>
            <p style="margin-left:20px;margin-right:1px;margin-top:0;margin-bottom: 0">每人每天允许最多预约</p>
            <el-input-number v-model="edi_userMaxTimes" :min="1" :max="100" :step="1" @change="KeepInfo"
                             style="margin: 0 6px">
            </el-input-number>
            <p>个时间段</p>
          </div>
          <div style="height:60px;display:flex;align-items: center">
            <p style="margin:0">客户不可约周期</p>
            <el-checkbox-group v-model="edi_check" @change="checksChange(edi_check)"
                               style="margin-top:6px;margin-left:18px">
              <el-checkbox v-for="city in rqS" :label="city" :key="city">{{ city }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="height:60px;display:flex;align-items: center">
            <p style="margin:0">同行不可约周期</p>
            <el-checkbox-group v-model="edi_check1" @change="checksChange1(edi_check1)"
                               style="margin-top:6px;margin-left:18px">
              <el-checkbox v-for="city in rqS" :label="city" :key="city">{{ city }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="height:auto;padding-bottom:10px">
            <div style="display: flex;">
              <p style="width:120px">客户不可约日期</p>
              <div style="display: flex;flex-flow:column">
                <div v-for="(d,index) in liNoKh" style="display:flex;align-items: center">
                  <el-date-picker
                      @change="changeNoKh(d,2)"
                      v-model="d.dates"
                      type="daterange"
                      :clearable="false"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="margin-left:10px;margin-top:10px">
                  </el-date-picker>
                  <i @click="addNoKh(index)" class="el-icon-plus"
                     style="margin-left:10px;margin-top:10px;font-size:20px;"></i>
                  <i v-if="index!==0" @click="delNoKh(d,index)" class="el-icon-minus"
                     style="margin-left:6px;margin-top:10px;font-size:20px;"></i>
                </div>
              </div>
            </div>
          </div>
          <div style="height:auto;padding-bottom:10px">
            <div style="display: flex;">
              <p style="width:120px">同行不可约日期</p>
              <div style="display: flex;flex-flow:column">
                <div v-for="(d,index) in liNoTh" style="display:flex;align-items: center">
                  <el-date-picker
                      @change="changeNoKh(d,1)"
                      v-model="d.dates"
                      type="daterange"
                      :clearable="false"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="margin-left:10px;margin-top:10px">
                  </el-date-picker>
                  <i @click="addNoTh(index)" class="el-icon-plus"
                     style="margin-left:10px;margin-top:10px;font-size:20px;"></i>
                  <i v-if="index!==0" @click="delNoTh(d,index)" class="el-icon-minus"
                     style="margin-left:6px;margin-top:10px;font-size:20px;"></i>
                </div>
              </div>
            </div>
          </div>
          <div style="height:auto;padding-bottom:10px">
            <div style="display: flex;">
              <p style="width:120px">客户可约时间段</p>
              <div style="display: flex;flex-flow:column">
                <div v-for="(d,index) in liYesKh" style="display:flex;align-items: center">
                  <el-time-select
                      placeholder="起始时间"
                      @change="changeYesKh(d,2)"
                      style="margin-left:10px;margin-top:10px;width:160px"
                      v-model="d['times'][0]"
                      :clearable="false"
                      :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59'
                    }">
                  </el-time-select>
                  <p style="margin-top:10px;margin-bottom:0;margin-left:5px;">至</p>
                  <el-time-select
                      placeholder="结束时间"
                      @change="changeYesKh(d,2)"
                      style="margin-left:5px;margin-top:10px;width:160px"
                      v-model="d['times'][1]"
                      :clearable="false"
                      :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '23:59',
                        minTime: d['times'][0]
                      }">
                  </el-time-select>
                  <p style="margin-left:15px;margin-top:10px;margin-bottom: 0">可约组数</p>
                  <el-input-number v-model="d.maxs" :min="1" :max="10000" :step="1" @change="changeYesKh(d,2)"
                                   style="margin-top:10px;margin-left:6px">
                  </el-input-number>
                  <p style="margin-left:6px;margin-top:10px;margin-bottom:0">组</p>
                  <i @click="addYesKh(index)" class="el-icon-plus"
                     style="margin-left:10px;margin-top:10px;font-size:20px;"></i>
                  <i v-if="index!==0" @click="delYesKh(d,index)" class="el-icon-minus"
                     style="margin-left:6px;margin-top:10px;font-size:20px;"></i>
                </div>
              </div>
            </div>
          </div>
          <div style="height:auto;padding-bottom:10px">
            <div style="display: flex;">
              <p style="width:120px">同行可约时间段</p>
              <div style="display: flex;flex-flow:column">
                <div v-for="(d,index) in liYesTh" style="display:flex;align-items: center">
                  <el-time-select
                      placeholder="起始时间"
                      @change="changeYesKh(d,1)"
                      style="margin-left:10px;margin-top:10px;width:160px"
                      v-model="d['times'][0]"
                      :clearable="false"
                      :picker-options="{
                      start: '00:00',
                      step: '00:01',
                      end: '23:59'
                    }">
                  </el-time-select>
                  <p style="margin-top:10px;margin-bottom:0;margin-left:5px;">至</p>
                  <el-time-select
                      placeholder="结束时间"
                      @change="changeYesKh(d,1)"
                      style="margin-left:5px;margin-top:10px;width:160px"
                      v-model="d['times'][1]"
                      :clearable="false"
                      :picker-options="{
                        start: '00:00',
                        step: '00:01',
                        end: '23:59',
                        minTime: d['times'][0]
                      }">
                  </el-time-select>
                  <!--                  <el-time-picker-->
                  <!--                      is-range-->
                  <!--                      @change="changeYesKh(d,1)"-->
                  <!--                      v-model="d.times"-->
                  <!--                      range-separator="至"-->
                  <!--                      :clearable="false"-->
                  <!--                      format='HH:mm'-->
                  <!--                      start-placeholder="开始时间"-->
                  <!--                      end-placeholder="结束时间"-->
                  <!--                      placeholder="选择时间范围"-->
                  <!--                      style="margin-left:10px;margin-top:10px">-->
                  <!--                  </el-time-picker>-->
                  <p style="margin-left:15px;margin-top:10px;margin-bottom: 0">可约组数</p>
                  <el-input-number v-model="d.maxs" :min="1" :max="10000" :step="1" @change="changeYesKh(d,1)"
                                   style="margin-top:10px;margin-left:6px">
                  </el-input-number>
                  <p style="margin-left:6px;margin-top:10px;margin-bottom:0">组</p>
                  <i @click="addYesTh(index)" class="el-icon-plus"
                     style="margin-left:10px;margin-top:10px;font-size:20px;"></i>
                  <i v-if="index!==0" @click="delYesTh(d,index)" class="el-icon-minus"
                     style="margin-left:6px;margin-top:10px;font-size:20px;"></i>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex;padding-bottom:10px">
            <p style="width:110px">关怀产品</p>
            <div v-for="(d,index) in liDev"
                 style="width:120px;margin-left:5px;display:flex;background: #b3d8ff;justify-content:center;align-items: center">
              <p @click="changeDevTc(d,index)" style="width:90%;text-align:center">{{ d.name }}</p>
              <i v-if="index!==0" @click="delDev(d)" class="el-icon-close"
                 style="margin-left:auto;margin-right:5px;margin-top:5px;font-size:20px;"></i>
            </div>
            <el-button @click="addDevTc" type="primary" icon="el-icon-plus" style="margin-left:20px">添加标签
            </el-button>
          </div>
          <div style="display: flex;padding-bottom:10px">
            <p style="width:110px">同行人关怀</p>
            <div v-for="(d,index) in liTx"
                 style="width:120px;margin-left:5px;display:flex;background: #b3d8ff;justify-content: center;align-items: center">
              <p @click="changeTxTc(d,index)" style="width:90%;text-align:center">{{ d.name }}</p>
              <i v-if="index!==0" @click="delTx(d)" class="el-icon-close"
                 style="margin-left:auto;margin-right:5px;margin-top:5px;font-size:20px;"></i>
            </div>
            <el-button @click="addTxTc" type="primary" icon="el-icon-plus" style="margin-left:20px">添加标签
            </el-button>
          </div>
          <div style="padding-top:20px;padding-bottom:50px">
            <!--            <el-button @click="KeepInfo" type="primary" style="margin-left:26vw">保存信息-->
            <!--            </el-button>-->
          </div>
        </div>
        <div v-else style="padding-left:10px;padding-right:10px;padding-top:10px;background-color: #FFFFFF">
          <div style="height:40px;background-color:#FFFFFF;">
            <el-select v-model="edi_type" ref='devSonSelect'
                       @change="getMarketAppointList"
                       clearable filterable placeholder="预约类型"
                       style="width:8vw;">
              <el-option
                  v-for="item in li_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="edi_state" ref='devSonSelect'
                       @change="getMarketAppointList"
                       clearable filterable placeholder="预约状态"
                       style="width:8vw;">
              <el-option
                  v-for="item in li_state"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <!--            <el-date-picker-->
            <!--                v-model="ediTime"-->
            <!--                type="datetimerange"-->
            <!--                @change="getMarketAppointList"-->
            <!--                range-separator="至"-->
            <!--                start-placeholder="开始日期"-->
            <!--                end-placeholder="结束日期">-->
            <!--            </el-date-picker>-->
            <el-input
                placeholder="昵称"
                style="width:10vw;margin-left:5px"
                prefix-icon="el-icon-search"
                clearable
                @change="getMarketAppointList"
                v-model="ediNickName">
            </el-input>
            <el-input
                placeholder="名称"
                style="width:10vw;margin-left:5px"
                prefix-icon="el-icon-search"
                clearable
                @change="getMarketAppointList"
                v-model="ediName">
            </el-input>
            <el-input
                placeholder="手机号"
                style="width:10vw;margin-left:5px"
                prefix-icon="el-icon-search"
                clearable
                @change="getMarketAppointList"
                v-model="ediPhone">
            </el-input>
            <el-input
                placeholder="公司"
                style="width:10vw;margin-left:5px"
                prefix-icon="el-icon-search"
                clearable
                @change="getMarketAppointList"
                v-model="ediCompany">
            </el-input>
          </div>
          <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                    style="width:100%; font-size:13px; background:#FFFFFF;margin-top: 10px"
                    show-overflow-tooltip
                    :header-cell-style="{'height':'30px','text-align':'center','background':'#f4f4f4','color':'#0dA7C8'}">
            <el-table-column width="01" sortable/>
            <div v-for="(d,item) in this.defHead">
              <el-table-column :key=item :prop=d.val :label=d.key :width="d.w">
              </el-table-column>
            </div>
            <el-table-column
                label="操作"
                width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state==='待审批'" @click="onReview(scope.row)" type="text" size="small"
                           style="color: #02A7F0;font-size: 14px;">审核
                </el-button>
                <el-button @click="onDel(scope.row)" type="text" size="small"
                           style="color:red;font-size: 14px">删除
                </el-button>
                <el-button @click="onCopy(scope.row)" type="text" size="small"
                           style="color:#8c95ff;font-size: 14px;">复制
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              style="float:right; margin-right:0.5vw;margin-top:5px;color: #000000;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange1"
              :current-page="page"
              :page-sizes="[10,20,30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </el-main>
      <el-footer style="background-color:#F4F4F4;height:1px;margin-bottom:10px;padding:0"></el-footer>
    </el-container>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="15vw" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiApp'> <!--v-draggable 拖动-->
      <div
          style="display:flex;margin-bottom:20px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <el-input placeholder="请输入名称" style="width:100%;height:30px;" v-model="edi_name"></el-input>
      </div>
      <div style="display:flex;width:100%;margin-top:10px">
        <el-button type="primary" @click="daiApp=false" style="margin-left:auto;margin-right:5px">取消</el-button>
        <el-button type="primary" @click="addDev" style="margin-left:5px;margin-right:5px">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审核" center :close-on-click-modal="false"
               width="20vw" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiReview'> <!--v-draggable 拖动-->
      <div
          style="display:flex;margin-bottom:20px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <el-input placeholder="请输入审核备注" style="width:100%;height:30px;" v-model="edi_bz"></el-input>
      </div>
      <div style="display:flex;width:100%;margin-top:10px">
        <el-button type="primary" @click="daiReview=false" style="margin-left:auto;margin-right:5px">返回</el-button>
        <el-button type="warning" @click="setReview(6)" style="margin-left:30px;margin-right:5px">拒绝</el-button>
        <el-button type="primary" @click="setReview(2)" style="margin-left:5px;margin-right:5px">通过</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDel"
        width="30%">
      <span>确定删除该预约吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDel = false">取 消</el-button>
        <el-button type="primary" @click=delYy()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import moment from "moment/moment";

export default {
  name:"resvSeeGl",
  components:{ /*引入组件*/

  },
  data() {
    return {
      is_one:true,
      isSet:0,
      h_text:"参观预约管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      xz_id:0,
      xz_index:"",
      id_dev:"",
      id_tx:"",
      edi_bz:"",
      edi_name:"",
      liWeek:[],
      liWeek1:[],
      liDev:[{id:1,name:"标签一"}],
      liTx:[{id:1,name:"标签一"}],
      liNoKh:[
        {
          id:0,
          dates:[
            new Date(),
            new Date()
          ]
        }
      ],
      liNoTh:[
        {
          id:0,
          dates:[
            new Date(),
            new Date()
          ]
        }
      ],
      liYesKh:[
        {
          id:0,
          times:[
            "08:00",
            "18:00"
          ],
          maxs:20
        }
      ],
      liYesTh:[
        {
          id:0,
          times:[
            "00:05",
            "18:00"
          ],
          maxs:2
        }
      ],
      edi_pwr:true,
      edi_needApprovalType1:true, /*1:同行，2客户*/
      edi_needApprovalType2:true,
      edi_day:20,
      edi_userMaxTimes:5,
      edi_pid:"",
      li_pid:[],
      divStyle:{
        backgroundColor:'#F4F4F4',
        overflow:'auto',
        paddingLeft:'16px',
        paddingRight:'16px',
        maxHeight:window.innerHeight - 50
      },
      daiApp:false,
      daiDel:false,
      daiReview:false,
      showInfo:{},
      titles:"预约详情",
      ediTime:"",
      ediName:"",
      ediPhone:"",
      ediCompany:"",
      ediNickName:"",
      ediDay:new Date(),
      ediDayZb:new Date(),
      completed:0,
      inProgress:0,
      notStarted:0,
      pidPage:1,
      pidPageSize:30,
      pidTotal:30,
      page:1,
      pageSize:10,
      total:0,
      defHead:[
        {'key':"类型",'val':"typeName","w":"200px"},
        {'key':"参观日期",'val':"timeDate","w":"auto"},
        {'key':"参观时间",'val':"times","w":"auto"},
        {'key':"参观人数",'val':"num","w":"auto"},
        {'key':"昵称",'val':"nickName","w":"auto"},
        {'key':"姓名",'val':"name","w":"auto"},
        {'key':"手机号",'val':"phone","w":"auto"},
        {'key':"关注产品",'val':"products","w":"auto"},
        {'key':"同行人关怀",'val':"drinks","w":"auto"},
        {'key':"所属公司",'val':"company","w":"auto"},
        {'key':"所属部门",'val':"department","w":"auto"},
        {'key':"所属行业",'val':"field","w":"auto"},
        {'key':"所属城市",'val':"city","w":"auto"},
        {'key':"职业顾问",'val':"consultant","w":"auto"},
        {'key':"状态",'val':"state","w":"auto"}
      ],
      rqS:[
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
        "周日"
      ],
      edi_check:[],
      edi_check1:[],
      tabData:[],
      but_qs:"周",
      but_zb:"周",
      bj_dev_txt:"#ccc",
      bj_tab:"#FFFFFF", /*#283A4D*/
      qs_x:[
        1
      ],
      qs_list_name:[],
      series:[],
      zb_list:[],
      edi_type:"",
      edi_state:"",
      li_type:[
        {label:"业内预约",value:1},
        {label:"客户预约",value:2}
      ],
      li_state:[
        {label:"待审批",value:1},
        {label:"未开始",value:2},
        {label:"进行中",value:3},
        {label:"已结束",value:4},
        {label:"已取消",value:5},
        {label:"未通过",value:6}
      ]
    };
  },
  methods:{ /*方法存放*/
    onSet(ints) {
      this.isSet = ints;
      if (this.isSet) {
        this.getInfo();
      } else {
        this.getMarketAppointList();
      }
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    formatDateTime(date,name) { /*时间解析*/
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      let data = "";
      switch (name) {
        case "allDate":
          data = `${this.pad(month)}/${this.pad(day)}`;
          break;
        case "day":
          data = `${year}-${this.pad(month)}-${this.pad(day)}`;
          break;
      }
      return data;
    },
    getTimes(date) { /*时间解析*/
      const hour = date.getHours();
      const minute = date.getMinutes();
      // const second = date.getSeconds();
      return date.getHours() * 60 + date.getMinutes();
    },
    getTimes1(date) { /*时间解析*/
      const [hours,minutes] = date.split(':').map(Number);
      const totalSeconds = (hours * 60) + (minutes); // 计算分钟数
      return totalSeconds;
    },
    getWeek(edi_check) {
      let a = 0;
      for (let i = 0; i < edi_check.length; i++) {
        if (edi_check[i] === "周一") {
          a += 1;
        }
        if (edi_check[i] === "周二") {
          a += 2;
        }
        if (edi_check[i] === "周三") {
          a += 4;
        }
        if (edi_check[i] === "周四") {
          a += 8;
        }
        if (edi_check[i] === "周五") {
          a += 16;
        }
        if (edi_check[i] === "周六") {
          a += 32;
        }
        if (edi_check[i] === "周日") {
          a += 64;
        }
      }
      return a;
    },
    getWeek1(ints) {
      let a = [];
      let s = ints.toString(2).split('').reverse().join('');
      console.log("ssssssss",s);
      if (s.length === 7) {
        if (s[0] === '1') {
          a.push("周一");
        }
        if (s[1] === '1') {
          a.push("周二");
        }
        if (s[2] === '1') {
          a.push("周三");
        }
        if (s[3] === '1') {
          a.push("周四");
        }
        if (s[4] === '1') {
          a.push("周五");
        }
        if (s[5] === '1') {
          a.push("周六");
        }
        if (s[6] === '1') {
          a.push("周日");
        }
      } else if (s.length === 6) {
        if (s[0] === '1') {
          a.push("周一");
        }
        if (s[1] === '1') {
          a.push("周二");
        }
        if (s[2] === '1') {
          a.push("周三");
        }
        if (s[3] === '1') {
          a.push("周四");
        }
        if (s[4] === '1') {
          a.push("周五");
        }
        if (s[5] === '1') {
          a.push("周六");
        }
      } else if (s.length === 5) {
        if (s[0] === '1') {
          a.push("周一");
        }
        if (s[1] === '1') {
          a.push("周二");
        }
        if (s[2] === '1') {
          a.push("周三");
        }
        if (s[3] === '1') {
          a.push("周四");
        }
        if (s[4] === '1') {
          a.push("周五");
        }
      } else if (s.length === 4) {
        if (s[0] === '1') {
          a.push("周一");
        }
        if (s[1] === '1') {
          a.push("周二");
        }
        if (s[2] === '1') {
          a.push("周三");
        }
        if (s[3] === '1') {
          a.push("周四");
        }
      } else if (s.length === 3) {
        if (s[0] === '1') {
          a.push("周一");
        }
        if (s[1] === '1') {
          a.push("周二");
        }
        if (s[2] === '1') {
          a.push("周三");
        }
      } else if (s.length === 2) {
        if (s[0] === '1') {
          a.push("周一");
        }
        if (s[1] === '1') {
          a.push("周二");
        }
      } else if (s.length === 1) {
        if (s[0] === '1') {
          a.push("周一");
        }
      }
      return a;
    },
    getMinutes(m) {
      const h1 = m / 60;
      const m1 = m % 60;
      return new Date(2016,9,10,h1,m1);
    },
    getMinutes1(m) {
      const h1 = m / 60;
      const m1 = m % 60;
      return `${this.pad(parseInt(h1))}:${this.pad(parseInt(m1))}`;
    },
    getDates(s) {
      return new Date(s);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMarketAppointList();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getMarketAppointList();
    },
    onCopy(d) {
      console.log(d);
      let s = "";
      for (let i = 0; i < this.defHead.length; i++) {
        s = s + `${this.defHead[i].key}：${d[this.defHead[i].val]}\n`;
      }
      navigator.clipboard.writeText(s);
      this.$message.success("复制成功");
    },
    changeNoKh(d,ints) {
      console.log(d.dates);
      const params = {
        "typeId":ints,
        "invalidType":1, //1-日期时段,2-每周几
        "startDate":this.formatDateTime(d.dates[0],'day'),
        "endDate":this.formatDateTime(d.dates[1],'day'),
        "weekly":this.getWeek(this.edi_check),
        'projectId':localStorage.getItem("projectId")
      };
      let tmp_url = this.$urls.newInvalidTimeRange;
      if (d.id) {
        params["id"] = d.id;
        tmp_url = this.$urls.editInvalidTimeRange;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmp_url,params,headers).then(res => {
        console.log("changeNoKh:",res.data.data);
        this.$message.success("修改成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改数据失败");
        }
      });
    },
    changeYesKh(d,ints) {
      console.log(d.times);
      const params = {
        "typeId":ints,
        "invalidType":1, //1-日期时段,2-每周几
        "startTime":this.getTimes1(d.times[0]),
        "endTime":this.getTimes1(d.times[1]),
        "num":d.maxs,
        'projectId':localStorage.getItem("projectId")
      };
      let tmp_url = this.$urls.newValidTimeRange;
      if (d.id) {
        params["id"] = d.id;
        tmp_url = this.$urls.editValidTimeRange;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmp_url,params,headers).then(res => {
        console.log("changeNoKh:",res.data.data);
        this.$message.success("修改成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改数据失败");
        }
      });
    },
    addNoKh(index) {
      this.liNoKh.splice(index + 1,0,{
        id:0,
        dates:[
          "",
          ""
        ]
      });
    },
    delNoKh(d,index) {
      if (d.id) {
        const params = {
          "id":d.id,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delInvalidTimeRange,params,headers).then(res => {
          console.log("delYesKh:",res.data.data);
          this.$message.success("删除成功");
          this.getInfo();
          this.daiApp = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除数据失败");
          }
        });
      } else {
        this.liNoKh.splice(index,1);
      }
    },
    addNoTh(index) {
      this.liNoTh.splice(index + 1,0,{
        id:0,
        dates:[
          "",
          ""
        ]
      });
    },
    delNoTh(d,index) {
      if (d.id) {
        const params = {
          "id":d.id,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delInvalidTimeRange,params,headers).then(res => {
          console.log("delYesKh:",res.data.data);
          this.$message.success("删除成功");
          this.getInfo();
          this.daiApp = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除数据失败");
          }
        });
      } else {
        this.liNoTh.splice(index,1);
      }
    },
    addYesKh(index) {
      this.liYesKh.splice(index + 1,0,{
        id:0,
        times:[
          "",
          ""
        ],maxs:20
      });
    },
    delYesKh(d,index) {
      if (d.id) {
        const params = {
          "id":d.id,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delValidTimeRange,params,headers).then(res => {
          console.log("delYesKh:",res.data.data);
          this.$message.success("删除成功");
          this.getInfo();
          this.daiApp = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除数据失败");
          }
        });
      } else {
        this.liYesKh.splice(index,1);
      }
    },
    addYesTh(index) {
      this.liYesTh.splice(index + 1,0,{
        id:0,
        times:[
          "",
          ""
        ],maxs:2
      });
    },
    delYesTh(d,index) {
      // this.liYesTh.splice(index,1);
      if (d.id) {
        const params = {
          "id":d.id,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.delValidTimeRange,params,headers).then(res => {
          console.log("delYesKh:",res.data.data);
          this.$message.success("删除成功");
          this.getInfo();
          this.daiApp = false;
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("删除数据失败");
          }
        });
      } else {
        this.liYesKh.splice(index,1);
      }
    },
    addDevTc() {
      this.edi_name = "";
      this.titles = "添加关怀产品";
      this.daiApp = true;
    },
    addTxTc() {
      this.edi_name = "";
      this.titles = "添加同行人关怀";
      this.daiApp = true;
    },
    changeDevTc(d,index) {
      this.xz_index = index;
      this.id_dev = d.id;
      this.edi_name = d.name;
      this.titles = "修改关怀产品信息";
      this.daiApp = true;
    },
    changeTxTc(d,index) {
      this.xz_index = index;
      this.id_tx = d.id;
      this.edi_name = d.name;
      this.titles = "修改同行人关怀信息";
      this.daiApp = true;
    },
    delDev(d) {
      // this.liDev.splice(index,1);
      const params = {
        "id":d.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delInterestingProduct,params,headers).then(res => {
        console.log("delInterestingProduct:",res.data.data);
        this.$message.success("删除成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除数据失败");
        }
      });
    },
    delTx(d) {
      // this.liTx.splice(index,1);
      const params = {
        "id":d.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delInterestingDrink,params,headers).then(res => {
        console.log("delInterestingDrink:",res.data.data);
        this.$message.success("删除成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除数据失败");
        }
      });
    },
    addDev() {
      const params = {
        "name":this.edi_name,
        'projectId':localStorage.getItem("projectId")
      };
      let tmpUrl = this.$urls.newInterestingProduct;
      if (this.titles === "添加关怀产品") {
        // this.liDev.push(this.edi_name);
        tmpUrl = this.$urls.newInterestingProduct;
      } else if (this.titles === "添加同行人关怀") {
        // this.liTx.push(this.edi_name);
        tmpUrl = this.$urls.newInterestingDrink;
      } else if (this.titles === "修改关怀产品信息") {
        // this.liDev[this.xz_index] = this.edi_name;
        params["id"] = this.id_dev;
        tmpUrl = this.$urls.changeInterestingProduct;
      } else if (this.titles === "修改同行人关怀信息") {
        // this.liTx[this.xz_index] = this.edi_name;
        params["id"] = this.id_tx;
        tmpUrl = this.$urls.changeInterestingDrink;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmpUrl,params,headers).then(res => {
        console.log("editAppointSetting:",res.data.data);
        this.$message.success("添加成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("保存数据失败");
        }
      });
    },
    checksChange(val) {
      // let checkedCount = val.length;
      // this.checkAll = checkedCount === this.rqS.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
      console.log(val);
      const params = {
        "invalidType":2, //1-日期时段,2-每周几
        "typeId":2,
        'startDate':"",
        'endDate':"",
        "weekly":this.getWeek(val),
        'projectId':localStorage.getItem("projectId")
      };
      let tmp_url = this.$urls.newInvalidTimeRange;
      if (this.liWeek.length > 0) {
        params["id"] = this.liWeek[this.liWeek.length - 1].id;
        tmp_url = this.$urls.editInvalidTimeRange;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmp_url,params,headers).then(res => {
        console.log("changeNoKh:",res.data.data);
        this.$message.success("修改成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改数据失败");
        }
      });
    },
    checksChange1(val) {
      // let checkedCount = val.length;
      // this.checkAll = checkedCount === this.rqS.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
      console.log(val);
      const params = {
        "invalidType":2, //1-日期时段,2-每周几
        "typeId":1,
        'startDate':"",
        'endDate':"",
        "weekly":this.getWeek(val),
        'projectId':localStorage.getItem("projectId")
      };
      let tmp_url = this.$urls.newInvalidTimeRange;
      if (this.liWeek1.length > 0) {
        params["id"] = this.liWeek1[this.liWeek1.length - 1].id;
        tmp_url = this.$urls.editInvalidTimeRange;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmp_url,params,headers).then(res => {
        console.log("changeNoKh:",res.data.data);
        this.$message.success("修改成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改数据失败");
        }
      });
    },
    KeepInfo() {
      const params = {
        "isAppointing":this.edi_pwr,//是否可预约
        "needApprovalType1":this.edi_needApprovalType1,
        "needApprovalType2":this.edi_needApprovalType2,
        "needApproval":true,//是否需要审批
        "maxEarlyDay":this.edi_day,//最远可预约天数
        "userMaxTimes":this.edi_userMaxTimes, //每人每天允许预约最多几个时间段
        'projectId':localStorage.getItem("projectId")
      };
      let tmpUrl = this.$urls.editAppointSetting;
      if (this.is_one) {
        tmpUrl = this.$urls.newAppointSetting;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmpUrl,params,headers).then(res => {
        console.log("editAppointSetting:",res.data.data);
        this.$message.success("保存数据成功");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("保存数据失败");
        }
      });
    },
    getInfo() {
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointSetting,params,headers).then(res => {
        console.log("getInfo:",res.data.data);
        let l_d = res.data.data;
        this.is_one = false;
        this.edi_pwr = l_d["isAppointing"];
        this.edi_needApprovalType1 = l_d["needApprovalType1"];
        this.edi_needApprovalType2 = l_d["needApprovalType2"];
        this.edi_day = l_d["maxEarlyDay"];
        this.edi_userMaxTimes = l_d["userMaxTimes"];
        if (l_d["invalidTime"] && l_d["invalidTime"].length > 0) { /*不可约时间*/
          let l1 = [];
          let l2 = [];
          let l3 = [];
          let l4 = [];
          for (let i = 0; i < l_d["invalidTime"].length; i++) {
            if (l_d["invalidTime"][i]["invalidType"] === 2) { /*周期*/
              if (l_d["invalidTime"][i]["typeId"] === 2) {
                l3.push({"id":l_d["invalidTime"][i]["id"],"week":l_d["invalidTime"][i]["weekly"]});
              } else {
                l4.push({"id":l_d["invalidTime"][i]["id"],"week":l_d["invalidTime"][i]["weekly"]});
              }
            } else {
              if (l_d["invalidTime"][i]["typeId"] === 2) {
                l2.push({
                  "id":l_d["invalidTime"][i]["id"],
                  "maxs":l_d["invalidTime"][i]["num"],
                  'dates':[
                    this.getDates(l_d["invalidTime"][i]["startDate"]),
                    this.getDates(l_d["invalidTime"][i]["endDate"])
                  ]
                });
              } else {
                l1.push({
                  "id":l_d["invalidTime"][i]["id"],
                  "maxs":l_d["invalidTime"][i]["num"],
                  'dates':[
                    this.getDates(l_d["invalidTime"][i]["startDate"]),
                    this.getDates(l_d["invalidTime"][i]["endDate"])
                  ]
                });
              }
            }
          }
          if (l1.length > 0) {
            this.liNoTh = l1;
          }
          if (l2.length > 0) {
            this.liNoKh = l2;
          }
          if (l3.length > 0) {
            console.log("typeId2-客户",l3);
            this.liWeek = l3;
            this.edi_check = this.getWeek1(l3[l3.length - 1]["week"]);
          }
          if (l4.length > 0) {
            console.log("typeId1-同行",l4);
            this.liWeek1 = l4;
            this.edi_check1 = this.getWeek1(l4[l4.length - 1]["week"]);
          }
        }
        if (l_d["validTime"] && l_d["validTime"].length > 0) { /*可约时间*/
          let l1 = [];
          let l2 = [];
          for (let i = 0; i < l_d["validTime"].length; i++) {
            if (l_d["validTime"][i]["typeId"] === 2) {
              l2.push({
                "id":l_d["validTime"][i]["id"],
                "maxs":l_d["validTime"][i]["num"],
                'times':[
                  this.getMinutes1(l_d["validTime"][i]["startTime"]),
                  this.getMinutes1(l_d["validTime"][i]["endTime"])
                ]
              });
            } else {
              l1.push({
                "id":l_d["validTime"][i]["id"],
                "maxs":l_d["validTime"][i]["num"],
                'times':[
                  this.getMinutes1(l_d["validTime"][i]["startTime"]),
                  this.getMinutes1(l_d["validTime"][i]["endTime"])
                ]
              });
            }
          }
          if (l1.length > 0) {
            this.liYesTh = l1;
          }
          if (l2.length > 0) {
            this.liYesKh = l2;
          }
        }
        if (l_d["product"] && l_d["product"].length > 0) { /*产品*/
          const l = [];
          for (let i = 0; i < l_d["product"].length; i++) {
            l.push({id:l_d["product"][i]['id'],name:l_d["product"][i]['name']});
          }
          this.liDev = l;
        } else {
          this.liDev = [];
        }
        if (l_d["drink"] && l_d["drink"].length > 0) { /*同行*/
          const l = [];
          for (let i = 0; i < l_d["drink"].length; i++) {
            l.push({id:l_d["drink"][i]['id'],name:l_d["drink"][i]['name']});
          }
          this.liTx = l;
        } else {
          this.liTx = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    onDel(row) {
      console.log(row);
      this.xz_id = row.id;
      this.daiDel = true;
    },
    onReview(row) {
      console.log(row);
      this.xz_id = row.id;
      this.edi_bz = "";
      this.daiReview = true;
    },
    delYy() {
      const params = {
        "id":this.xz_id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delMarketAppoint,params,headers).then(res => {
        console.log("setReview：",res.data.data);
        this.$message.success("删除成功");
        this.daiDel = false;
        this.getMarketAppointList();
      }).catch(error => {
        console.log(error.data);
        this.loading = false;
        this.$message.error("删除失败");
      });
    },
    setReview(stateId) {
      const params = {
        "id":this.xz_id,
        "stateId":stateId,
        "approveNote":this.edi_bz,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.approveMarketAppoint,params,headers).then(res => {
        console.log("setReview：",res.data.data);
        this.$message.success("审核成功");
        this.daiReview = false;
        this.getMarketAppointList();
      }).catch(error => {
        console.log(error.data);
        this.loading = false;
        this.$message.error("设置失败");
      });
    },
    getPid() {
      if (this.pidPage > this.pidTotal / this.pidPageSize + 1) {
        return;
      }
      const params = {
        'page':this.pidPage,
        'pageSize':this.pidPageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getRoomList,params,headers).then(res => {
        console.log("getRoomList：",res.data.data);
        this.pidTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_pid;
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['id'],
            label:data[i]['name']
          };
          l.push(d);
        }
        this.li_pid = l;
        this.pidPage += 1;
        this.loading = false;
      }).catch(error => {
        console.log(error.data);
        this.loading = false;
        this.$message.error("获取设备类型失败");
      });
    },
    initQs(data,lt,t1) { /*初始化趋势折线图*/
      let li_name = [];
      let li_data = [];
      for (let i = 0; i < data.length; i++) {
        let name = "";
        let li_d = [];
        console.log(data[i][lt]);
        for (let j = 0; j < this.qs_x.length; j++) {
          let d = {};
          const re_d = data[i][lt].find(u => u[t1] === j);
          if (re_d) {
            name = re_d["roomName"];
            li_d.push(re_d["num"]);
          } else {
            li_d.push(0);
          }
        }
        if (name) {
          li_name.push(name);
          li_data.push(li_d);
        }
      }
      this.qs_list_name = li_name;
      let series = [];
      for (let i = 0; i < li_name.length; i++) {
        var color = '#' + Math.floor(Math.random() * 16777215).toString(16);
        let d = {
          name:li_name[i],
          data:li_data[i],
          type:'line',
          itemStyle:{
            color:color
          },
          areaStyle:{
            color:color // 底部填充颜色
          },
          tooltip:{
            valueFormatter:function (value) {
              return value;
            }
          }
        };
        series.push(d);
      }
      this.series = series;
      this.drawLine4();
    },
    drawLine1() {
      let myChart1 = this.$echarts.getInstanceByDom(
          document.getElementById('myChart1')
      );
      if (myChart1 == null) {  /*基于准备好的dom，初始化echarts实例*/
        this.myChart1 = this.$echarts.init(document.getElementById('myChart1'));
      } else {
        this.myChart1.clear();
      }
      this.myChart1.setOption({ /*绘制图表*/
        series:[
          {
            name:"", /*['女', '男']*/
            type:'pie',    // 设置图表类型为饼图
            radius:[
              '40%',
              '70%'
            ],  // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 66% 长kWh。
            data:this.zb_list,          // 数据数组，name 为数据项名称，value 为数据项值
            label:{ /*position:"", //标签的位置*/
              formatter:'{b}：{c}%',
              fontWeight:'normal',
              fontSize:13,
              color:this.bj_dev_txt,
              textStyle:{
                fontWeight:'bold' // 设置柱状图顶部的标签加粗
              }
            }
          }
        ]
      });
    },
    drawLine4() {
      let myChart4 = this.$echarts.getInstanceByDom(
          document.getElementById('myChart4')
      );
      if (myChart4 == null) {  /*基于准备好的dom，初始化echarts实例*/
        this.myChart4 = this.$echarts.init(document.getElementById('myChart4'));
      } else {
        this.myChart4.clear();
      }
      this.myChart4.setOption({ /*绘制图表*/
        title:{
          text:'', // 主标题
          subtext:'', // 副标题
          x:'left', // x轴方向对齐方式
          padding:[
            0,
            0,
            0,
            0
          ], /*上 右 下 左*/
          textStyle:{ /*图例文字的样式*/
            color:this.bj_dev_txt,
            fontSize:16
          }
        },
        tooltip:{
          trigger:'axis' // axis   item   none三个值
        },
        color:[
          '#4472C5',
          '#ED7C30',
          '#80FF80',
          '#FF8096',
          '#800080'
        ],
        legend:{
          orient:'horizontal', /*vertical*/
          x:'center',
          y:'top',
          padding:[
            20,
            0,
            0,
            0
          ], /*上 右 下 左*/
          data:this.qs_list_name,
          textStyle:{ /*图例文字的样式*/
            color:this.bj_dev_txt,
            fontSize:16
          }
        },
        grid:{
          left:'2%',
          right:'2%',
          bottom:'2%',
          containLabel:true
        },
        xAxis:{
          type:'category', // 还有其他的type，可以去官网喵两眼哦
          data:this.qs_x, // x轴数据
          name:'',  /*x轴名称*/
          show:true,
          axisLabel:{
            color:this.bj_dev_txt,
            fontSize:14
          }
        },
        yAxis:{
          type:'value',
          name:'',  /*y轴名称*/
          axisLabel:{
            color:this.bj_dev_txt,
            fontSize:14
          }
        },
        series:this.series
      });
    },
    getAppointRatio() { /*获取数据占比*/
      const params = {
        'type':0,
        'projectId':localStorage.getItem("projectId")
      };
      switch (this.but_zb) {
        case "日":
          params["type"] = 0;
          break;
        case "周":
          params["type"] = 1;
          break;
        case "月":
          params["type"] = 2;
          break;
        case "年":
          params["type"] = 3;
          break;
      }
      params["time"] = parseInt("" + this.ediDayZb.getTime() / 1000);
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAppointRatio,params,headers).then(res => {
        console.log("getAppointRatio:",res.data.data);
        if (res.data.data["appointRoom"]) {
          let li_d = res.data.data["appointRoom"];
          if (li_d.length > 0) {
            let l_zb = [];
            for (let i = 0; i < li_d.length; i++) {
              let d = {
                value:(li_d[i]["ratio"] * 100).toFixed(2),
                name:li_d[i]["roomName"],
                itemStyle:{
                  color:'#' + Math.floor(Math.random() * 16777215).toString(16)
                }
              };
              l_zb.push(d);
            }
            this.zb_list = l_zb;
          } else {
            this.zb_list = [];
          }
        } else {
          this.zb_list = [];
        }
        this.drawLine1();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取占比数据失败");
        }
      });
    },
    getAppointTotal() {
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAppointTotal,params,headers).then(res => {
        console.log("getAppointTotal:",res.data.data);
        this.completed = res.data.data.completed;
        this.inProgress = res.data.data.inProgress;
        this.notStarted = res.data.data.notStarted;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取统计数据失败");
        }
      });
    },
    getAppointInOneDay() {
      const params = {
        "type":0,
        'projectId':localStorage.getItem("projectId")
      };
      switch (this.but_qs) {
        case "日":
          params["type"] = 0;
          break;
        case "周":
          params["type"] = 1;
          break;
        case "月":
          params["type"] = 2;
          break;
        case "年":
          params["type"] = 3;
          break;
      }
      params["time"] = parseInt("" + this.ediDay.getTime() / 1000);
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointInOneDay,params,headers).then(res => {
        console.log("getAppointInOneDay:",res.data.data);
        switch (this.but_qs) {
          case "日":
            if (res.data.data["appointDay"]) {
              this.qs_x = Array.from({length:24},(_,index) => index);
              this.initQs(res.data.data["appointDay"],"appointRoomHour","hour");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
          case "周":
            if (res.data.data["appointWeek"]) {
              this.qs_x = Array.from({length:8},(_,index) => index);
              this.initQs(res.data.data["appointWeek"],"appointRoomWeek","week");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
          case "月":
            if (res.data.data["appointMonth"]) {
              this.qs_x = Array.from({length:moment().daysInMonth() + 1},(_,index) => index);
              this.initQs(res.data.data["appointMonth"],"appointRoomMonth","day");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
          case "年":
            if (res.data.data["appointYearWithRoomId"]) {
              this.qs_x = Array.from({length:13},(_,index) => index);
              this.initQs(res.data.data["appointYearWithRoomId"],"appointRoomYear","month");
            } else {
              this.series = [];
              this.qs_list_name = [];
              this.drawLine4();
            }
            break;
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取曲线数据失败");
        }
      });
    },
    initAppointList(li_data) {
      let data = li_data['list'];
      let l_d = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          "id":data[i]["id"],
          "userNo":data[i]["userNo"],
          "stateId":data[i]["stateId"],
          "typeId":data[i]["typeId"],
          "timeDate":data[i]["timeDate"],
          "num":data[i]["num"],
          "nickName":data[i]["weChatName"],//微信昵称
          "name":data[i]["leader"], //领队名称
          "phone":data[i]["leaderPhone"], //领队手机号
          "company":data[i]["company"],
          "department":data[i]["department"],
          "field":data[i]["field"],
          "city":data[i]["city"],
          "consultant":data[i]["consultant"],
          "valid":data[i]["valid"],
          "times":"",
          "products":"",
          "drinks":""
        };
        if (d.typeId === 2) {
          d["nickName"] = data[i]["nickName"];//微信昵称
          d["name"] = data[i]["name"]; //领队名称
          d["phone"] = data[i]["phone"]; //领队手机号
        }
        let re_type = this.li_type.find(item => item.value === d.typeId);
        if (re_type) {
          d["typeName"] = re_type.label;
        }
        let re_d = this.li_state.find(item => item.value === d.stateId);
        if (re_d) {
          d["state"] = re_d.label;
        }
        if (d["valid"]) {
          d["times"] = `${this.getMinutes1(d["valid"]["startTime"])}-${this.getMinutes1(d["valid"]["endTime"])}`;
        }
        for (let j = 0; j < data[i]["products"].length; j++) {
          d["products"] = `${d["products"]}${data[i]["products"][j]["name"]}、`;
        }
        for (let j = 0; j < data[i]["drinks"].length; j++) {
          d["drinks"] = `${d["drinks"]}${data[i]["drinks"][j]["name"]}、`;
        }
        if (d["products"].length > 0) {
          d["products"] = d["products"].slice(0,-1);
        }
        if (d["drinks"].length > 0) {
          d["drinks"] = d["drinks"].slice(0,-1);
        }
        l_d.push(d);
      }
      this.total = li_data.total;
      this.tabData = l_d;
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    getMarketAppointList() { /*获取所有预约信息*/
      const params = {
        "page":this.page,
        "pageSize":this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTime) {
        params['beginExpDate'] = this.timestampToTime(this.ediTime[0]);
        params['endExpDate'] = this.timestampToTime(this.ediTime[1]);
      }
      if (this.ediName) {
        params['userName'] = this.ediName;
      }
      if (this.ediNickName) {
        params['nickName'] = this.ediNickName;
      }
      if (this.ediPhone) {
        params['phone'] = this.ediPhone;
      }
      if (this.ediCompany) { /*房间id*/
        params['company'] = this.ediCompany;
      }
      if (this.edi_type) {/*类型id*/
        params['typeId'] = this.edi_type;
      }
      if (this.edi_state) {/*状态id*/
        params['stateId'] = this.edi_state;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getMarketAppointList,params,headers).then(res => {
        console.log("getMarketAppointList:",res.data.data);
        if ("list" in res.data.data && res.data.data.list) {
          console.log(res.data.data);
          this.initAppointList(res.data.data);
        } else {
          this.total = 0;
          this.tabData = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取预约数据失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    //this.getAppointTotal();
    //this.getAppointRatio();
    //this.getAppointInOneDay();
    this.getInfo();
    this.getMarketAppointList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>

#resvSeeGl {
  height: 95vh;
  margin: 0;
  padding-top: 0;
  background: #F4F4F4;
}

.resvSee_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 1vh;
  overflow-y: auto;
  border-radius: 5px 5px 5px 5px;
}

.actSee1 {
  color: #FFFFFF;
  background: #02A7F0;
  border: 1px solid black;
}

.actSee {
  background: #FFFFFF;
  border: 1px solid black;
}

.dialogApp {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    text-align: left;
    background: linear-gradient(to right, #6366F1, #10B981);
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/resvSeeGl.vue